module.exports = __webpack_public_path__ + "img/nt54-03-80-1-asm.prt.75b2c6a1.jpg";